export default __webpack_public_path__ + "static/media/inlet.075e5f0d.png";